import type { SVGProps } from "react";
import { memo } from "react";
const Proton = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#B0084D" />
        <stop offset="100%" stopColor="#FF4F8B" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="m34.231 27.64-5-6 1.537-1.28 4.7 5.64h17.117l-2.292-2.293 1.414-1.414 4 4a1 1 0 0 1 0 1.414l-4 4-1.414-1.414L52.585 28H35c-.297 0-.579-.132-.769-.36m21.476 24.653a1 1 0 0 1 0 1.414l-4 4-1.414-1.414L52.585 54H35.468l-4.7 5.64-1.537-1.28 5-6c.19-.228.472-.36.769-.36h17.585l-2.292-2.293 1.414-1.414zm12-11.586-4 4-1.414-1.414L64.585 41H41v-2h23.585l-2.292-2.293 1.414-1.414 4 4a1 1 0 0 1 0 1.414M18 66c-2.206 0-4-1.795-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4m9-26c0-2.206 1.794-4 4-4s4 1.794 4 4-1.794 4-4 4-4-1.795-4-4M14 18c0-2.206 1.794-4 4-4s4 1.794 4 4-1.794 4-4 4-4-1.795-4-4m7.77 39.339 8.741-11.364c.162.013.324.025.489.025 3.308 0 6-2.692 6-6 0-3.309-2.692-6-6-6-.165 0-.327.012-.489.025L21.77 22.661A5.99 5.99 0 0 0 24 18c0-3.309-2.692-6-6-6-3.309 0-6 2.691-6 6 0 3.308 2.691 6 6 6 .704 0 1.377-.129 2.005-.352l8.417 10.942A6 6 0 0 0 25 40a6 6 0 0 0 3.422 5.41l-8.417 10.942A6 6 0 0 0 18 56c-3.309 0-6 2.691-6 6 0 3.308 2.691 6 6 6 3.308 0 6-2.692 6-6a5.99 5.99 0 0 0-2.23-4.661"
      />
    </g>
  </svg>
);
const Memo = memo(Proton);
export default Memo;
